import { render, staticRenderFns } from "./ValidationUpdateCommunication.vue?vue&type=template&id=3e962f88&"
import script from "./ValidationUpdateCommunication.vue?vue&type=script&lang=js&"
export * from "./ValidationUpdateCommunication.vue?vue&type=script&lang=js&"
import style0 from "./ValidationUpdateCommunication.vue?vue&type=style&index=0&id=3e962f88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports